import { useEffect } from 'react';
import { useStripeAmount } from '../contexts/StripeAmountContext';

/**
 * Hook that listens for stripe-amount-update events and updates the context
 * This provides a bridge between the existing event-based system and the new context
 */
export const useStripeAmountUpdater = () => {
  const { updateAmount } = useStripeAmount();

  useEffect(() => {
    const handleAmountUpdate = (event: CustomEvent) => {
      const newAmount = event.detail.amount;
      if (newAmount) {
        updateAmount(newAmount);
      }
    };

    window.addEventListener('stripe-amount-update' as any, handleAmountUpdate as any);
    return () => {
      window.removeEventListener('stripe-amount-update' as any, handleAmountUpdate as any);
    };
  }, [updateAmount]);
};